// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// hello world
export const environment = {
  production: false,

  api: {
    // BASE_URL: 'https://edms.upltest.com.ng/api/v1/'
    BASE_URL: 'https://upperdocs.ng/public/api/v1/'
  },
  // API_URL: 'https://edms.upltest.com.ng/api',
  API_URL: 'https://edms-back.uplsv.com.ng/public/api',
  API_VERSION: 'v1',
  FIREBASE: {
    apiKey: "AIzaSyAznQnj8jUf946ZZrSj8XGDHrhAyHq2I_4",
    authDomain: "webchoice-222411.firebaseapp.com",
    databaseURL: "https://webchoice-222411.firebaseio.com",
    projectId: "webchoice-222411",
    storageBucket: "webchoice-222411.appspot.com",
    messagingSenderId: "1022834333635",
    appId: "1:1022834333635:web:f08bb2fd1d26b584bfcf76"
  },
  IP: {
    first: '192.168.8.5',
    second: '10.21.99.3',
  }
};
